export const stafflistGet = (workerData) => {
    let workerDataTemp = workerData?.data || {};
    let response = {};
    response["success"] = workerDataTemp.success === true;
    response["total"] = workerDataTemp.total || 0;
    response["data"] = Array.isArray(workerDataTemp.data) ? workerDataTemp.data.map(user => ({
        id: user.id || null,
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        email: user.email || '',
        contact_number: user.contact_number || '',
        profile_img_url: user.profile_img_url || null,
        is_active: user.is_active ?? false,
        select_all_business: user.select_all_business ?? false,
        UserOrgBranchRoleRelation: Array.isArray(user.UserOrgBranchRoleRelation) ? user.UserOrgBranchRoleRelation.map(rel => ({
            id: rel.id || null,
            user_id: rel.user_id || null,
            org_id: rel.org_id || null,
            branch_id: rel.branch_id || null,
            role_id: rel.role_id || null,
            user_type: rel.user_type || null,
            branch_name: rel.branch_name || null,
            role_name: rel.role_name || null,
            OrgUserRelation: rel.OrgUserRelation ? {
                id: rel.OrgUserRelation?.id || null,
                org_name: rel.OrgUserRelation?.org_name || null,
                is_mfa_required: rel.OrgUserRelation?.is_mfa_required ?? false,
                is_active: rel.OrgUserRelation?.is_active ?? false,
                OrgMetaRelation: rel.OrgUserRelation?.OrgMetaRelation ? {
                    id: rel.OrgUserRelation.OrgMetaRelation?.id || null,
                    org_id: rel.OrgUserRelation.OrgMetaRelation?.org_id || null,
                    email: rel.OrgUserRelation.OrgMetaRelation?.email || null,
                    contact_number: rel.OrgUserRelation.OrgMetaRelation?.contact_number || null,
                    address1: rel.OrgUserRelation.OrgMetaRelation?.address1 || null,
                    address2: rel.OrgUserRelation.OrgMetaRelation?.address2 || null,
                    city: rel.OrgUserRelation.OrgMetaRelation?.city || null,
                    zip: rel.OrgUserRelation.OrgMetaRelation?.zip || null,
                    state: rel.OrgUserRelation.OrgMetaRelation?.state || null,
                    country: rel.OrgUserRelation.OrgMetaRelation?.country || null,
                    time_zone: rel.OrgUserRelation.OrgMetaRelation?.time_zone || null,
                    is_active: rel.OrgUserRelation.OrgMetaRelation?.is_active ?? false,
                    is_standalone: rel.OrgUserRelation.OrgMetaRelation?.is_standalone ?? false,
                    org_logo: rel.OrgUserRelation.OrgMetaRelation?.org_logo || null
                } : null
            } : null,
            UserMetaRelation: rel.UserMetaRelation ? {
                id: rel.UserMetaRelation?.id || null,
                user_id: rel.UserMetaRelation?.user_id || null
            } : null
        })) : []
    })) : [];
    return response;
}

export const userDetailsGet = (userData) => {
    let resData = {};
    let data = [];
    if (userData.data.success) {
        let userDetailsTempHash = {};
        userDetailsTempHash.user_details = {};

        let userDetailsApiResData = userData.data.data.length > 0 ? userData.data.data[0] : [];
        userDetailsTempHash.user_details.active = userDetailsApiResData.hasOwnProperty('active') && userDetailsApiResData.active ? userDetailsApiResData.active : "";
        userDetailsTempHash.user_details.contact_number = userDetailsApiResData.hasOwnProperty('contact_number') && userDetailsApiResData.contact_number ? userDetailsApiResData.contact_number : "";
        userDetailsTempHash.user_details.email = userDetailsApiResData.hasOwnProperty('email') && userDetailsApiResData.email ? userDetailsApiResData.email : "";
        userDetailsTempHash.user_details.first_name = userDetailsApiResData.hasOwnProperty('first_name') && userDetailsApiResData.first_name ? userDetailsApiResData.first_name : "";
        userDetailsTempHash.user_details.id = userDetailsApiResData.hasOwnProperty('id') && userDetailsApiResData.id ? userDetailsApiResData.id : "";
        userDetailsTempHash.user_details.last_name = userDetailsApiResData.hasOwnProperty('last_name') && userDetailsApiResData.last_name ? userDetailsApiResData.last_name : "";
        userDetailsTempHash.user_details.profile_img = userDetailsApiResData.hasOwnProperty('profile_img_url') && userDetailsApiResData.profile_img_url ? userDetailsApiResData.profile_img_url : {};

        data.push(userDetailsTempHash);
        resData = {
            "success": userData.data.success,
            "total": userData.data.total,
            "data": data
        }
    } else {
        resData = {
            "success": false,
            "message": 'Something went wrong'
        }
    }

    return resData;
}

export const staffStatusUpdateApi = (data) => {
    return data.data;
}
export const staffCreatePost = (data) => {
    return data.data;
}
export const staffCreatePatch = (data) => {
    return data.data;
}
export const individualUserApiGet = (data) => {
    return data.data;
}
export const allHotelsListApiGet = (data) => {
    return data.data;
}
export const staffDeleteApi = (data) => {
    return data.data;
}
export const getHotelBranchListGet = (data) => {
    return data.data;
}
export const getRoomTypeListGet = (data) => {
    return data.data;
}
export const roleListGetApi = (data) => {
    return data.data;
}

export const staffHistoryGet = (data)=>{
    return data.data;
}
